import { SettingConst } from '@faire/web-api--source/types';

/**
 * Operating SLA in milliseconds for Phone in different countries
 */
export const HELP_CENTER_PHONE_SLA = 'HELP_CENTER_PHONE_SLA' as SettingConst<
  'HELP_CENTER_PHONE_SLA',
  number,
  'HELP_CENTER' | 'RETAILER_IOS' | 'RETAILER_ANDROID'
>;
